import ValueBetweenFilter from './ValueBetweenFilter';
import DateBetweenFilter from './DateBetweenFilter';
import { GridFilterOperator } from '@mui/x-data-grid-pro';

export const valueBetweenOperator: GridFilterOperator = {
  label: 'is between',
  value: 'between',
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || typeof filterItem.value !== 'string' || !filterItem.value.includes(',')) {
      return null;
    }

    const [minStr, maxStr] = filterItem.value.split(',').map((s) => s.trim());
    const min = parseFloat(minStr);
    const max = parseFloat(maxStr);

    if (isNaN(min) || isNaN(max)) {
      return null;
    }

    return ({ value }) => {
      const numericValue = parseFloat(value);
      if (isNaN(value)) return false;
      return numericValue >= min && numericValue <= max;
    };
  },
  InputComponent: ValueBetweenFilter,
};

export const dateBetweenOperator: GridFilterOperator = {
  label: 'is between',
  value: 'dateBetween',
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.value || typeof filterItem.value !== 'string' || !filterItem.value.includes(',')) {
      return null;
    }

    const [from, to] = filterItem.value.split(',');
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      return null;
    }

    return ({ value }) => {
      const cellDate = new Date(value);
      return cellDate >= fromDate && cellDate <= toDate;
    };
  },
  InputComponent: DateBetweenFilter,
};
